export class DumbNonInvoicePaymentItem {
    constructor(){
        this.amount = 0;
        this.reason = 0;
    }
    amount: number;
    reason: number;
    hasAmountError:boolean;
    hasReasonError:boolean;
    reasonIsMembershipDues() {return this.reason == 1;}
}
